import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navyDeep text-silverDark" data-id="element-88" data-mp="3geze367ujv27">
      <div className="metal-bar h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggk72reij5xy" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32onkt3zizq9h">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="36pfsvtwnvp46">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3uf0phflqmkvx">Created by meteorology specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-silverEdge pt-6 text-xs" data-id="element-93" data-mp="38qvaxf23pqn">
          © 2026 {productName} — All rights reserved.
        </p>
      </div>
    </footer>;
}